import React from 'react';
import './Gift.css';

const Gift = () => {
  return (
    <div className="gift-container">
      <h2 className="gift-title">Special Gifts For You</h2>
      <div className="gift-content">
        {/* First Gift Card */}
        <div className="gift-card">
          <div className="gift-image">
            <img src="/447020952_985419569929286_5042747400193896647_n.jpg" alt="Gift 1" />
          </div>
          <div className="gift-text">
            <h3>Dear Special Someone</h3>
            <p>
              Thank you for visiting my portfolio. I have a special gift waiting for you.
              Click the button below to reveal your surprise!
            </p>
            <button className="gift-button">
              Open Your Gift
            </button>
          </div>
        </div>

        {/* Second Gift Card */}
        <div className="gift-card">
          <div className="gift-image">
            <img src="/gift-image2.jpg" alt="Gift 2" />
          </div>
          <div className="gift-text">
            <h3>Exclusive Offer</h3>
            <p>
              Here's another surprise just for you! This gift will help you improve your skills.
              Click below to get your reward.
            </p>
            <button className="gift-button">
              Reveal Your Reward
            </button>
          </div>
        </div>

        {/* Third Gift Card */}
        <div className="gift-card">
          <div className="gift-image">
            <img src="/gift-image3.jpg" alt="Gift 3" />
          </div>
          <div className="gift-text">
            <h3>Thank You Gift</h3>
            <p>
              I truly appreciate your time. This gift will assist you on your journey. Enjoy!
            </p>
            <button className="gift-button">
              Claim Your Gift
            </button>
          </div>
        </div>

        {/* Additional gift cards can be added in the same pattern */}
      </div>
    </div>
  );
};

export default Gift;
